import { Field, NumberField, TextField } from 'payload';
import { FieldDefault, FieldWithouType } from '@utils/fields'
import { mergeObjects, replaceKeyValue } from '@utils/objects'
import { MaskedFieldOptions } from '@components/(payload)/fields/text/masked'

/**
 * Convert a string to masked value
 *
 * @param options
 * @returns
 */
export const convertMaskString = (options) => {
  options = replaceKeyValue(options, 'mask', Number, 'number');
  return options;
}

/**
 * Creates a TextField with IMask
 *
 * @param config
 * @param options
 * @returns
 */
export function maskedField<TField extends CustomPayloadField<Field> = CustomPayloadField<TextField>>(config: FieldWithouType<CustomPayloadField<TextField>> | NumberField, options?: MaskedFieldOptions): TField[] {
  const configDefault: Omit<FieldDefault<CustomPayloadField<TextField>>, 'type'> = {
    admin: {
      components: {
        Field: {
          path: '@components/(payload)/fields/text/masked',
          clientProps: {
            options
          }
        },
      }
    }
  }

  const field: CustomPayloadField<TField> = mergeObjects(mergeObjects({ type: 'text' }, config), configDefault);
  return [ field ];
}
